import * as TypeGraphQL from "type-graphql";
export var ModelVersionStatus;
(function (ModelVersionStatus) {
    ModelVersionStatus["TRAINING"] = "TRAINING";
    ModelVersionStatus["VALIDATION"] = "VALIDATION";
    ModelVersionStatus["DEPLOYED"] = "DEPLOYED";
    ModelVersionStatus["DEPRECATED"] = "DEPRECATED";
    ModelVersionStatus["FAILED"] = "FAILED";
})(ModelVersionStatus || (ModelVersionStatus = {}));
TypeGraphQL.registerEnumType(ModelVersionStatus, {
    name: "ModelVersionStatus",
    description: undefined,
});
//# sourceMappingURL=ModelVersionStatus.js.map